import * as React from 'react'
import { memo } from 'react'
const SvgArrowLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <path d="M1.209 6.313H12v-.627H1.209L6.448.447 6 0 0 6l6 6 .448-.448Z" />
  </svg>
)
const Memo = memo(SvgArrowLeft)
export default Memo
